import styled from "styled-components";
import {
  TablePageCard,
  TablePageContainer,
  TablePageTitle,
} from "components/TablePageLayout";
import { pxToRem } from "../../styles/utils";

export const CoursesPageContainer = styled(TablePageContainer)``;

export const ContentWrapper = styled(TablePageCard)`
  margin-left: 0;
  overflow-x: auto;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => pxToRem(theme.spacing.lg)};
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xxl)};
`;

export const Title = styled(TablePageTitle)``;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${({ theme }) => pxToRem(theme.spacing.md)};
  width: min(100%, ${pxToRem(500)});
  margin-top: ${({ theme }) => pxToRem(theme.spacing.xl)};
`;

export const ButtonsContainer = styled.div.attrs({ className: "table-actions" })`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => pxToRem(theme.spacing.lg)};
`;
